import React, { useState, useEffect } from 'react';
import { shuffleArray } from '../utils';
import questionsData from '../data/questions';
import QuestionCard from './QuestionCard';

const GameScreen = ({ selectedCategory, onBack }) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [randomLabelsForQuestions, setRandomLabelsForQuestions] = useState([]);

  // Category titles
  const categoryTitles = {
    HappyHour: "🍹 Happy Hour",
    OnTheRocks: "🥃 On The Rocks",
    LastCall: "🍸 Last Call",
    ExtraDirty: "🍷 Extra Dirty",
  };

  // Random labels and unique gradients for each label
  const randomLabels = [
    {
      text: "STRAIGHT UP",
      gradient: "bg-gradient-to-r from-yellow-400 to-yellow-600",
    },
    {
      text: "MAKE IT A DOUBLE",
      gradient: "bg-gradient-to-r from-blue-400 to-blue-600",
    },
    {
      text: "THIS ROUND’S ON ME",
      gradient: "bg-gradient-to-r from-pink-400 to-pink-600",
    },
  ];

  // Shuffle and set questions when category changes
  useEffect(() => {
    const filteredQuestions = questionsData[selectedCategory] || [];
    const shuffledQuestions = shuffleArray(filteredQuestions);
    setQuestions(shuffledQuestions);
    setCurrentQuestionIndex(0); // Reset to the first question

    // Generate random labels for each question, but keep them consistent for each visit
    const generatedLabels = shuffledQuestions.map(() => {
      const randomIndex = Math.floor(Math.random() * randomLabels.length);
      return randomLabels[randomIndex];
    });

    setRandomLabelsForQuestions(generatedLabels);
  }, [selectedCategory]); // Only trigger when selectedCategory changes

  // Handle next question
  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  // Handle previous question
  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
      {/* Back Button */}
      <button
        className="absolute top-4 left-4 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md"
        onClick={onBack}
      >
        Back to Menu
      </button>

      {questions.length > 0 ? (
        <>
          {/* Display category title */}
          <h2 className="text-4xl font-semibold mb-4">{categoryTitles[selectedCategory]}</h2>

          {/* Display random label with its gradient for the current question */}
          <div
            className={`text-xl font-bold text-white p-2 rounded-lg mb-4 ${randomLabelsForQuestions[currentQuestionIndex]?.gradient}`}
          >
            {randomLabelsForQuestions[currentQuestionIndex]?.text}
          </div>

          {/* Display question card */}
          <QuestionCard
            question={questions[currentQuestionIndex]}
          />

          <div className="flex justify-between w-full max-w-lg mt-4">
            {/* Previous Button */}
            <button
              onClick={handlePreviousQuestion}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
              disabled={currentQuestionIndex === 0}
            >
              ⬅️ Previous
            </button>

            {/* Next Button */}
            <button
              onClick={handleNextQuestion}
              className="bg-blue-500 text-white px-4 py-2 rounded-lg"
              disabled={currentQuestionIndex === questions.length - 1}
            >
              Next ➡️
            </button>
          </div>
        </>
      ) : (
        <p>Loading questions...</p>
      )}
    </div>
  );
};

export default GameScreen;
